 // In your component class (design-product.component.ts)

 interface DesignProduct {
  id: number;
  product_code: string;
  product_name: string;
  image: string;
  metal_data?: MetalItem[];
  stone_data?: StoneItem[];
  packaging_data?: PackagingItem[];
  total_price: number;
  total_thread: number;
  image_url?: string;
  [key: string]: any;
}

interface MetalItem {
  code: string;
  artical_name: string;
  quantity: number;
  product_id?: number;
  per_piece_weight?: number;
  total_weight?: number;
}

interface StoneItem {
  code: string;
  stone_name: string;
  quantity: number;
  product_id?: number;
}

interface PackagingItem {
  product_code: string;
  material_name: string;
  quantity: number;
  product_id?: number;
}


import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import { NotificationService } from '../../../../Services/notification.service';
import { MetalService } from '../../../../Services/metal.service';
import { PackagingService } from '../../../../Services/Product_Creation/packaging.service';
import { ProductService } from '../../../../Services/product.service';
import { StockGeneralService } from '../../../../Services/Product_Creation/stock-general.service';
import { StockPriceService } from '../../../../Services/Product_Creation/stock-price.service';
import { environment } from '../../../../../environments/environment';

interface DesignProduct {
  id: number;
  product_code: string;
  product_name: string;
  image: string;
  metal_data?: MetalItem[];
  stone_data?: StoneItem[];
  packaging_data?: PackagingItem[];
  total_price: number;
  total_thread: number;
  image_url?: string;
  
}

interface MetalItem {
  code: string;
  artical_name: string;
  quantity: number;
  product_id?: number;
}

interface StoneItem {
  code: string;
  stone_name: string;
  quantity: number;
  product_id?: number;
}

interface PackagingItem {
  product_code: string;
  material_name: string;
  quantity: number;
  product_id?: number;
}


@Component({
  selector: 'app-design-product',
  imports: [NgIf, NgFor,NgSwitch,NgSwitchDefault,NgSwitchCase, FormsModule, RouterLink],
  templateUrl: './design-product.component.html',
  styleUrl: './design-product.component.css',
})
export class DesignProductComponent implements OnInit {
  totalPages: number = 0;
  searchValues: { [key: string]: string } = {};
  globalSearchText: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortKey: string = '';
  showDropdown: boolean = false;
  paginatedDesignProductList: DesignProduct[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  visibleRowCount: number = 10;
  designProductList: DesignProduct[] = [];
  purchasePrice: any;
  purchasePriceData:any;
  metalDataList: MetalItem[] = [];
  stoneDataList: StoneItem[] = [];
  filteredDesignProducts: DesignProduct[] = [];
startDate: string = ''; 
  endDate: string = ''; 
  packagingDataList: PackagingItem[] = [];
  designImageMap = new Map<string | number, string>();


  imagePreviews: string[] = ['assets/image/add-image.png'];
  fileUploadError: string[] = ['', '', ''];

  selectedFields: {
    key: string;
    label: string;
    selected: boolean;
    isCustom?: boolean;
    subFields?: { key: string; label: string }[];
  }[] = [
    { key: 'image', label: 'Image', selected: true, isCustom: true },
    { key: 'unique_code_sku', label: 'Product Code', selected: true },
    { key: 'product_name', label: 'Product Name', selected: true },
    {
      key: 'metal_data',
      label: 'Metal Details',
      selected: true,
      isCustom: true,
      subFields: [
        { key: 'code', label: 'Code' },
        { key: 'artical_name', label: 'Name' },
        { key: 'quantity', label: 'Qty' },
      ],
    },
    {
      key: 'stone_data',
      label: 'Stone Details',
      selected: true,
      isCustom: true,
      subFields: [
        { key: 'code', label: 'Code' },
        { key: 'stone_name', label: 'Name' },
        { key: 'quantity', label: 'Qty' },
      ],
    },
    {
      key: 'packaging_data',
      label: 'Packaging Details',
      selected: true,
      isCustom: true,
      subFields: [
        { key: 'code', label: 'Code' },
        { key: 'package_type', label: 'Type' },
        { key: 'quantity', label: 'Qty' },
      ],
    },
    { key: 'silver_rate', label: 'Silver Rate', selected: true, isCustom: true },
    { key: 'silver_weight', label: 'Silver Weight', selected: true, isCustom: true },
    { key: 'total_price', label: 'Total Price', selected: true, isCustom: true },
    { key: 'labour_charges', label: 'Labour charges', selected: true, isCustom: true },
    { key: 'total_thread', label: 'Total Thread', selected: true, isCustom: true },
  ];
    purchasePriceList!: any[];
  latestPrice: any;

  constructor(
    private notificationService: NotificationService,
    private metalService: MetalService,
    private productService: ProductService,
    private packagingService: PackagingService,
    private stockGeneralService: StockGeneralService,
    private stockPriceService:StockPriceService
  ) {}

  ngOnInit(): void {
    const savedSelections = localStorage.getItem('designProductColumnSelections');
    if (savedSelections) {
      this.selectedFields = JSON.parse(savedSelections);
    }

    this.itemsPerPage = this.visibleRowCount;
    this.getDesignProductList();
  }

  getDesignProductList() {
    this.stockGeneralService.getGeneralProductCodeForProductDesign().subscribe({
      next: (response: any) => {
        const rawProducts = response?.data || [];

        this.designProductList = rawProducts.map((item: any) => ({
          id: item.id,
          unique_code_sku: item.model_number || 'N/A',
          product_name: item.product_name || 'N/A',
          product_image: item.product_image,
          product_image_2 : item.product_image_2,
          product_image_3 : item.product_image_3,
          product_image_4 : item.product_image_4,
          product_image_5 : item.product_image_5,
          created_at: item.created_at,

          // Mapping as per your table template
          metal_data: item.assembly_metal_part || [],
          stone_data: item.assembly_stone || [],
          packaging_data: item.packaging || [],

          // Extract latest price info (e.g. first price entry)
          latest_price_info: item.latest_product_price || {}
        })).reverse();

        this.totalPages = Math.ceil(this.designProductList.length / this.itemsPerPage);
        this.updatePaginatedList();
      },
      error: (error: any) => {
        this.notificationService.showError('Failed to load products.', 'Error');
        console.error('Error fetching product list:', error);
      }
    });
  }

filterTable() {

  let filtered = this.designProductList.filter((item: any) => {

    /* ================= DATE FILTER ================= */

    if (this.startDate || this.endDate) {

      const createdAt = item['created_at'];
      if (!createdAt) return false;

      const itemDate = new Date(createdAt).setHours(0, 0, 0, 0);
      const start = this.startDate
        ? new Date(this.startDate).setHours(0, 0, 0, 0)
        : null;
      const end = this.endDate
        ? new Date(this.endDate).setHours(0, 0, 0, 0)
        : null;

      if (start && itemDate < start) return false;
      if (end && itemDate > end) return false;
    }

    /* ================= COLUMN FILTER ================= */

    const matchesFieldFilters = this.selectedFields.every((field) => {

      const searchTerm = (this.searchValues[field.key] || '')
        .trim()
        .toLowerCase();

      if (!searchTerm) return true;

      if (
        field.isCustom &&
        (field.key === 'metal_data' ||
         field.key === 'stone_data' ||
         field.key === 'packaging_data')
      ) {

        return item[field.key]?.some((subItem: any) =>
          Object.values(subItem).some(val =>
            (val ?? '')
              .toString()
              .toLowerCase()
              .includes(searchTerm)
          )
        ) || false;

      } else {

        const fieldValue = (item[field.key] ?? '')
          .toString()
          .toLowerCase();

        return fieldValue.includes(searchTerm);
      }
    });

    /* ================= GLOBAL SEARCH ================= */

    const matchesGlobalSearch = this.globalSearchText
      ? Object.values(item).some(val =>
          (val ?? '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearchText.trim().toLowerCase())
        )
      : true;

    return matchesFieldFilters && matchesGlobalSearch;
  });

  /* ================= SORT ================= */

  if (this.sortKey) {
    filtered.sort((a: any, b: any) => {

      const valA = a[this.sortKey] ?? '';
      const valB = b[this.sortKey] ?? '';

      return this.sortDirection === 'asc'
        ? valA > valB ? 1 : valA < valB ? -1 : 0
        : valA < valB ? 1 : valA > valB ? -1 : 0;
    });
  }

  /* ================= SAVE FULL FILTERED DATA ================= */

  this.filteredDesignProducts = filtered;

  /* ================= PAGINATION ================= */

  this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);

  const startIndex = (this.currentPage - 1) * this.itemsPerPage;

  this.paginatedDesignProductList = filtered.slice(
    startIndex,
    startIndex + this.itemsPerPage
  );
}


  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedDesignProductList = this.designProductList.slice(start, end);
  }

  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDirection = 'asc';
    }
    this.filterTable();
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedList();
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedList();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedList();
    }
  }

  get pageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5; // Adjust as needed
    const startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

    if (startPage > 1) {
      pages.push(1);
      if (startPage > 2) {
        pages.push(0); // Represents '...'
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < this.totalPages) {
      if (endPage < this.totalPages - 1) {
        pages.push(0); // Represents '...'
      }
      pages.push(this.totalPages);
    }
    return pages.filter(page => page !== 0); // Remove the '0' if it's the only page
  }

  updateVisibleRows() {
    this.itemsPerPage = this.visibleRowCount;
    this.currentPage = 1;
    this.filterTable();
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onFieldToggle(field: any) {
    field.selected = !field.selected;
    this.saveSelectedFields();
    this.filterTable();
  }

  saveSelectedFields() {
    localStorage.setItem(
      'designProductColumnSelections',
      JSON.stringify(this.selectedFields)
    );
  }

  selectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = true));
    this.saveSelectedFields();
    this.filterTable();
  }

  deselectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = false));
    this.saveSelectedFields();
    this.filterTable();
  }

  restoreColumnSelection() {
    localStorage.removeItem('designProductColumnSelections');
    this.selectedFields = [
      { key: 'unique_code_sku', label: 'Product Code', selected: true },
      { key: 'product_name', label: 'Product Name', selected: true },
      { key: 'image', label: 'Image', selected: true, isCustom: true },
      {
        key: 'metal_data',
        label: 'Metal Details',
        selected: true,
        isCustom: true,
        subFields: [
          { key: 'code', label: 'Code' },
          { key: 'artical_name', label: 'Name' },
          { key: 'quantity', label: 'Qty' },
        ],
      },
      {
        key: 'stone_data',
        label: 'Stone Details',
        selected: true,
        isCustom: true,
        subFields: [
          { key: 'code', label: 'Code' },
          { key: 'stone_name', label: 'Name' },
          { key: 'quantity', label: 'Qty' },
        ],
      },
      {
        key: 'packaging_data',
        label: 'Packaging Details',
        selected: true,
        isCustom: true,
        subFields: [
          { key: 'code', label: 'Code' },
          { key: 'package_type', label: 'Type' },
          { key: 'quantity', label: 'Qty' },
        ],
      },
      { key: 'silver_rate', label: 'Silver Rate', selected: true, isCustom: true },
      { key: 'silver_weight', label: 'Silver Weight', selected: true, isCustom: true },
      { key: 'total_price', label: 'Total Price', selected: true, isCustom: true },
      { key: 'labour_charges', label: 'Labour charges', selected: true, isCustom: true },
      { key: 'total_thread', label: 'Thread Price', selected: true, isCustom: true },
    ];
    this.filterTable();
  }

  get selectedFieldss() {
    return this.selectedFields.filter((field) => field.selected);
  }
/* ============================================================
   IMAGE PROXY HELPERS
============================================================ */

proxyImageUrl(url: string): string {

  if (!url) return url;

  if (url.includes('/api/image-proxy/')) return url;

  const match = url.match(/\/storage\/(.+)$/);

  if (!match) return url;

  const backendBase =
    environment.apiBaseUrl.replace(/\/api\/$/, '');

  return `${backendBase}/api/image-proxy/${match[1]}`;
}


/* ============================================================
   LOAD IMAGE AS BASE64
============================================================ */

async loadImageBase64(url: string): Promise<string | null> {

  try {

    const proxiedUrl = this.proxyImageUrl(url);

    console.log('🟡 Loading image:', proxiedUrl);

    const res = await fetch(proxiedUrl);

    if (!res.ok) throw new Error(res.statusText);

    const blob = await res.blob();

    const base64 = await new Promise<string>(resolve => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });

    console.log('✅ BASE64 READY');

    return base64;

  } catch (err) {

    console.error('🔥 Image load failed:', url, err);

    return null;
  }
}


/* ============================================================
   PRELOAD ONLY FIRST IMAGE PER PRODUCT
============================================================ */

async prepareDesignImages(): Promise<void> {

  console.log('========== PDF IMAGE PRELOAD START ==========');

  for (const row of this.paginatedDesignProductList as any[]) {

    console.log('ROW RAW:', row);

    if (!row.product_image) continue;

    console.log('➡ Loading image for row:', row.id);

    row.__img = await this.loadImageBase64(row.product_image);

    console.log(
      'ATTACHED TO ROW:',
      row.__img ? 'YES ✅' : 'NO ❌'
    );
  }

  console.log('========== PDF IMAGE PRELOAD END ==========');
}


/* ============================================================
   MAIN PDF EXPORT
============================================================ */

async downloadPDF(): Promise<void> {

  // 🔥 preload images first
  await this.prepareDesignImages();

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a3',
  });

  const selectedFields =
    this.selectedFields
      .filter(f => f.selected)
      .filter(f =>
        ![
          'product_image_2',
          'product_image_3',
          'product_image_4',
          'product_image_5',
        ].includes(f.key)
      );

  if (!selectedFields.length) {
    this.notificationService.showError(
      'Please select at least one column',
      'Error'
    );
    return;
  }

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  /* ================= HEADER ================= */

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);

  doc.text(
    'Design Product List',
    pageWidth / 2,
    16,
    { align: 'center' }
  );

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);

  doc.text(
    `Generated on: ${new Date().toLocaleString()}`,
    pageWidth - 15,
    10,
    { align: 'right' }
  );

  /* ================= TABLE ================= */

  const headers = [
    { header: 'No.', dataKey: 'no' },
    ...selectedFields.map(f => ({
      header: f.label,
      dataKey: f.key,
    })),
  ];

  const exportData = this.getExportData();

const body = exportData.map((item, index) => {


    console.log('PDF ROW RAW:', item);

    const row: any = { no: index + 1 };

    selectedFields.forEach(f => {

      /* ================= IMAGE ================= */

      if (f.key === 'image') {
        row.image = '';
        row.__img = item['__img'];
        return;
      }

      /* ================= TOTAL PRICE ================= */

      if (f.key === 'total_price') {

        const priceObj = item['latest_price_info'];

        console.log('PDF PRICE OBJ:', priceObj);

        let total = 0;

        if (priceObj) {

          if (priceObj.purchase_price) {
            total = Number(priceObj.purchase_price);
          } else {
            total =
              Number(priceObj.subunit_price || 0) +
              Number(priceObj.labour_charges || 0);
          }
        }

        row.total_price = total ? total.toFixed(2) : '-';

        return;
      }

      /* ================= THREAD ================= */

      if (f.key === 'total_thread') {

        const priceObj = item['latest_price_info'];

        row.total_thread =
          priceObj?.thread_price ??
          '-';

        return;
      }

      /* ================= METAL ================= */

      if (f.key === 'metal_data') {

        const metals = item['metal_data'];

        console.log('PDF METAL RAW:', metals);

        if (!Array.isArray(metals) || !metals.length) {
          row.metal_data = 'N/A';
          return;
        }

        const header =
          'Code | Name | Per Piece WT | Total Silver WT | Qty';

        const rows = metals.map((m: any) =>
          [
            m.code,
            m.artical_name,
            m.per_piece_weight,
            m.total_weight,
            m.quantity,
          ]
            .map(v => String(v ?? '-'))
            .join(' | ')
        );

        row.metal_data = [header, ...rows].join('\n');

        return;
      }

      /* ================= STONE ================= */

      if (f.key === 'stone_data') {

        const stones = item['stone_data'];

        if (!Array.isArray(stones) || !stones.length) {
          row.stone_data = 'N/A';
          return;
        }

        const header = 'Code | Name | Qty';

        const rows = stones.map((s: any) =>
          [
            s.code,
            s.stone_name,
            s.quantity,
          ]
            .map(v => String(v ?? '-'))
            .join(' | ')
        );

        row.stone_data = [header, ...rows].join('\n');

        return;
      }

      /* ================= PACKAGING ================= */

      if (f.key === 'packaging_data') {

        const packs = item['packaging_data'];

        if (!Array.isArray(packs) || !packs.length) {
          row.packaging_data = 'N/A';
          return;
        }

        const header = 'Material | Qty';

        const rows = packs.map((p: any) =>
          [
            p.material_name,
            p.quantity,
          ]
            .map(v => String(v ?? '-'))
            .join(' | ')
        );

        row.packaging_data = [header, ...rows].join('\n');

        return;
      }

      /* ================= NORMAL ================= */

      row[f.key] = item[f.key] ?? '-';

    });

    return row;
  }
);



  autoTable(doc, {

    columns: headers,
    body,

    startY: 24,

    margin: { left: 6, right: 6 },

    theme: 'grid',

    horizontalPageBreak: false,

    rowPageBreak: 'auto',

    tableWidth: pageWidth - 12,

    /* ---------- STYLES ---------- */

    styles: {
      fontSize: 6.5,
      cellPadding: 2,
      overflow: 'linebreak',
      valign: 'middle',
    },

    headStyles: {
      fillColor: [0, 123, 255],
      textColor: 255,
      halign: 'center',
      fontSize: 7,
      fontStyle: 'bold',
    },

    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },

    columnStyles: {
      no: { cellWidth: 12, halign: 'center' },
      image: { cellWidth: 30 },
    },

    /* ---------- IMAGE ROW HEIGHT ---------- */

    didParseCell: data => {

      if (
        data.section === 'body' &&
        data.column.dataKey === 'image'
      ) {

        data.cell.styles.minCellHeight = 28;
        data.cell.styles.halign = 'center';
        data.cell.styles.valign = 'middle';
      }
    },

    /* ---------- DRAW IMAGE ---------- */

    didDrawCell: data => {

      if (data.column.dataKey !== 'image') return;

      const rowAny = data.row.raw as any;

      console.log('DRAW CELL RAW:', rowAny);

      const img = rowAny?.__img;

      console.log(
        'DRAW IMAGE:',
        img ? 'YES ✅' : 'NO ❌'
      );

      if (!img) return;

      try {

        const size = 22;

        const x =
          data.cell.x +
          (data.cell.width - size) / 2;

        const y =
          data.cell.y +
          (data.cell.height - size) / 2;

        doc.addImage(
          img,
          'JPEG',
          x,
          y,
          size,
          size,
          undefined,
          'FAST'
        );

        console.log('🖼 IMAGE DRAWN');

      } catch (err) {

        console.error('❌ addImage failed:', err);

      }
    },

    /* ---------- FOOTER ---------- */

    didDrawPage: () => {

      doc.setFontSize(8);

      doc.text(
        `Page ${(doc as any).getNumberOfPages()}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
    },

  });

  doc.save('design-product-list.pdf');
}


 downloadExcel(): void {
  const selectedFields = this.selectedFields.filter(
    (field) => field.selected
  );

  const exportData = this.getExportData();

const data = exportData.map((item, index) => {
    const row: any = { 'No.': index + 1 };
let totalPrice = 0;

const priceObj = item['latest_price_info'];

if (priceObj) {
  const purchase = Number(priceObj.purchase_price || 0);

  if (purchase > 0) {
    totalPrice = purchase;
  } else {
    const sub = Number(priceObj.subunit_price || 0);
    const labour = Number(priceObj.labour_charges || 0);
    totalPrice = sub + labour;
  }
}

if (!totalPrice && Array.isArray(item['metal_data'])) {
  item['metal_data'].forEach((m: any) => {
    totalPrice += Number(m.total_price || 0);
  });
}


    /* ===============================
       ROW BUILD
    ================================ */

    selectedFields.forEach((field) => {
      let value: any = '';

      if (field.isCustom) {
        if (field.key === 'image') {
          value = 'Image available';
        }

        else if (
          field.key === 'metal_data' ||
          field.key === 'stone_data' ||
          field.key === 'packaging_data'
        ) {
          const raw = item[field.key];
          value = raw ? JSON.stringify(raw) : '';
        }

        else if (field.key === 'total_price') {
          value = totalPrice;
        }

        else {
          value = item[field.key] ?? '';
        }

      } else {
        value = item[field.key] ?? '';
      }

      row[field.label] = value;
    });

    /* ===============================
       FORCE NUMERIC COLUMN
    ================================ */

    row['Total Price'] = totalPrice;

    return row;
  });

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

  /* ===============================
     FORCE NUMBER TYPE
  ================================ */

  Object.keys(worksheet).forEach((cell) => {
    if (cell.startsWith('!')) return;

    const c = worksheet[cell];

    if (typeof c.v === 'number') {
      c.t = 'n';
    }
  });

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Design Product List': worksheet },
    SheetNames: ['Design Product List'],
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  FileSaver.saveAs(
    new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    'design-product-list.xlsx'
  );
}



  downloadJSONAll(): void {
     const data = this.getExportData();
    const jsonString = JSON.stringify(data, null, 2);

    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileName = 'design-product-list.json';

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(link.href);
  }

  downloadCSV(): void {
    const data = this.getExportData();
    if (!data.length) return;

    const selectedFields = this.selectedFields?.filter((f) => f.selected) || [];
    const headers = ['No.', ...selectedFields.map((f) => f.label)];
    const keys = selectedFields.map((f) => f.key);

    let csvContent = headers.join(',') + '\n';

    data.forEach((item, index) => {
      const row = [
        index + 1,
        ...keys.map((key) => {
          let value = item[key];
          if (key === 'image') {
            value = 'Image available';
          } else if (key === 'metal_data' || key === 'stone_data' || key === 'packaging_data') {
            value = JSON.stringify(item[key]);
          }

          return typeof value === 'string' && value.includes(',')
            ? `"${value}"`
            : value ?? '';
        }),
      ];
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = 'design-product-list.csv';

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();

    URL.revokeObjectURL(link.href);
  }

async printTable() {

  console.log('========== PRINT START ==========');

  // preload images into __img
  await this.prepareDesignImages();

  const data = this.getExportData();


  console.log('PRINT DATA SAMPLE:', data[0]);

  let printContent = `
  <html>
  <head>
    <title>Design Product List</title>

    <style>

      body {
        font-family: Arial, sans-serif;
        margin: 0;
      }

      h3 {
        text-align: center;
        margin-bottom: 10px;
      }

      /* =============================
         MAIN TABLE
      ============================== */

      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        font-size: 11px;
      }

      th, td {
        border-right: 2px solid #000;
        border-bottom: 2px solid #000;
        padding: 6px;
        text-align: center;
        vertical-align: middle;
        white-space: nowrap;
      }

      th:first-child,
      td:first-child {
        border-left: 2px solid #000;
      }

      thead th {
        border-top: 2px solid #000;
        background: #f2f2f2;
        font-weight: 600;
      }

      tbody tr:last-child td {
        border-bottom: 2px solid #000;
      }

      img {
        max-width: 70px;
        max-height: 70px;
        object-fit: contain;
        display: block;
        margin: auto;
      }

      /* =============================
         SUB TABLES
      ============================== */

      .sub-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 10px;
      }

      .sub-table th,
      .sub-table td {
        border: 1px solid #000;
        padding: 3px;
        text-align: center;
      }

      .sub-table thead th {
        background: #eee;
        font-weight: 600;
      }
/* FORCE vertical borders inside sub tables */

.sub-table th:last-child,
.sub-table td:last-child {
  border-right: 2px solid #000 !important;
}

.sub-table th:first-child,
.sub-table td:first-child {
  border-left: 2px solid #000 !important;
}

/* ensure outer border visible */

.sub-table {
  border: 2px solid #000;
}

      /* =============================
         PRINT
      ============================== */

      @media print {

        @page {
          size: auto;
          margin: 8mm;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        thead {
          display: table-header-group;
        }

        tr {
          page-break-inside: avoid;
        }
      }

    </style>

  </head>
  <body>

    <h3>Design Product List</h3>

    <table>
      <thead>
        <tr>
          <th>No.</th>
  `;

  /* ================= HEADERS ================= */

  this.selectedFields.forEach(field => {
    if (field.selected) {
      printContent += `<th>${field.label}</th>`;
    }
  });

  printContent += `
        </tr>
      </thead>
      <tbody>
  `;

  /* ================= ROWS ================= */

  data.forEach((item: any, index: number) => {

    console.log('ROW RAW:', item);
    console.log('PRICE OBJ:', item['latest_price_info']);

    printContent += `
      <tr>
        <td>${index + 1}</td>
    `;

    this.selectedFields.forEach(field => {

      if (!field.selected) return;

      let displayValue: string = '';

      const value = item[field.key];

      /* ================= IMAGE ================= */

      if (field.key === 'image') {

        const base64Img =
          item['__img'] ||
          item['product_image'] ||
          '';

        displayValue = base64Img
          ? `<img src="${base64Img}" />`
          : '-';
      }

      /* ================= METAL ================= */

      else if (field.key === 'metal_data') {

  console.log('METAL RAW:', value);

  if (Array.isArray(value) && value.length) {

    displayValue = `
      <table class="sub-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Per Piece WT</th>
            <th>Total Silver WT</th>
            <th>Qty</th>
          </tr>
        </thead>
        <tbody>
          ${value.map((m: any) => {

            const perPiece =
              m.per_piece_weight ?? '-';

            const silverWt =
              m.total_weight ?? '-';

            return `
              <tr>
                <td>${m.code ?? '-'}</td>
                <td>${m.artical_name ?? '-'}</td>
                <td>${perPiece}</td>
                <td>${silverWt}</td>
                <td>${m.quantity ?? '-'}</td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>
    `;

  } else {
    displayValue = '-';
  }
}

      /* ================= STONE ================= */

      else if (field.key === 'stone_data') {

        if (Array.isArray(value) && value.length) {

          displayValue = `
            <table class="sub-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                ${value.map((s: any) => `
                  <tr>
                    <td>${s.code ?? '-'}</td>
                    <td>${s.stone_name ?? '-'}</td>
                    <td>${s.quantity ?? '-'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          `;

        } else {
          displayValue = '-';
        }
      }

      /* ================= PACKAGING ================= */

      else if (field.key === 'packaging_data') {

        if (Array.isArray(value) && value.length) {

          displayValue = `
            <table class="sub-table">
              <thead>
                <tr>
                  <th>Material</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                ${value.map((p: any) => `
                  <tr>
                    <td>${p.material_name ?? '-'}</td>
                    <td>${p.quantity ?? '-'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          `;

        } else {
          displayValue = '-';
        }
      }

      /* ================= TOTAL PRICE ================= */

      else if (field.key === 'total_price') {

        const priceObj = item['latest_price_info'];

        if (item['total_price']) {
          displayValue = String(item['total_price']);
        }
        else if (priceObj) {

          const base =
            Number(priceObj.subunit_price ?? 0);

          const labour =
            Number(priceObj.labour_charges ?? 0);

          const other =
            Number(priceObj.other_charges ?? 0);

          displayValue =
            (base + labour + other).toFixed(2);

        } else {
          displayValue = '-';
        }
      }

      /* ================= TOTAL THREAD ================= */

      else if (field.key === 'total_thread') {

        displayValue = String(
          item['total_thread'] ??
          item['st_total_thread'] ??
          '-'
        );
      }

      /* ================= OBJECT SAFE ================= */

      else if (value && typeof value === 'object') {

        displayValue =
          value.name ||
          value.title ||
          '';
      }

      /* ================= NORMAL ================= */

      else {

        displayValue = String(value ?? '-');
      }

      printContent += `<td>${displayValue}</td>`;
    });

    printContent += `</tr>`;
  });

  printContent += `
      </tbody>
    </table>

  </body>
  </html>
  `;

  const printWindow = window.open('', '_blank');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  }

  console.log('========== PRINT END ==========');
}



  // openMetalDetails, openStoneDetails, and openPackagingDetails methods are removed
  // as the data is now directly embedded in the table.
  // Make sure to remove any calls to these methods in your HTML.

  private generateDummyPrice(): number {
    return parseFloat((Math.random() * 2000 + 100).toFixed(2));
  }

  private generateDummyThread(): number {
    return Math.floor(Math.random() * 50) + 1;
  }

  onImageSelected(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        this.fileUploadError[index] = 'File size should not exceed 2MB.';
        this.imagePreviews[index] = 'assets/image/add-image.png';
        return;
      }
      this.fileUploadError[index] = '';

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreviews[index] = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  deleteDesignProduct(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this product!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
      customClass: {
        confirmButton: 'swal2-confirm-button',
        cancelButton: 'swal2-cancel-button'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.stockGeneralService.deleteProduct(id).subscribe(
          (response: any) => {
            this.notificationService.showSuccess('Product deleted successfully!', 'Success');
            this.getDesignProductList();
          },
          (error: any) => {
            this.notificationService.showError('Failed to delete product. Please try again.', 'Error');
            console.error('Error deleting product:', error);
          }
        );
      }
    });
  }
  // method for the date filter and show in the all reports 
  private getExportData(): DesignProduct[] {

  const hasFilter =
    this.startDate ||
    this.endDate ||
    this.globalSearchText ||
    Object.values(this.searchValues).some(v => v);

  return hasFilter
    ? this.filteredDesignProducts
    : this.designProductList;
}



}
